import React, { useState, useEffect } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import ClearIcon from '@mui/icons-material/Clear';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import AddIcon from '@mui/icons-material/Add';
import ServiceMissionVehicule from '../services/vehiculeMissionService';
import ServiceVehicule from '../services/vehiculeService'; 
import PersonnelService from '../services/personnelService';
import { useNavigate, Link } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';

// PAGINATION
const ITEMS_PER_PAGE = 5;

function Vehicule() {
  const [vehiculesMission, setVehiculesMission] = useState([]);
  const [personnels, setPersonnel] = useState([]);
  const [vehicules, setVehicule] = useState([]);
  const [currentVehicule, setCurrentVehicule] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [drivers, setDrivers] = useState([]);

  const fetchData = () => {
    ServiceMissionVehicule.all()
      .then(result => {
          setVehiculesMission(result.data);
      })
      .catch(error => alert(error.error));

    ServiceVehicule.all()
    .then(result => {
    if (result.success) {
      setVehicule(result.data['data']);
      }
    })
    .catch(error => alert(error.error));

    ServiceVehicule.drivers()
    .then(result => {
      if (result.success) {
        setDrivers(result.data['data']);
      }
    })
    .catch(error => alert(error.error));

    PersonnelService.all()
      .then(result => {
        if (result.success) {
          setPersonnel(result.data);
        }
      })
      .catch(error => alert(error.error));
  };

  useEffect(() => {
    fetchData();
  }, []);

  
  // EDIT MODAL
  const [openEditModal, setOpenEditModal] = useState(false);
  const handleCloseEditModal = () => setOpenEditModal(false);
  const handleOpenEditModal = (vehicule) => {
    setCurrentVehicule(vehicule);
    setOpenEditModal(true);
  };

  // DELETE MODAL
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const handleCloseDeleteModal = () => setOpenDeleteModal(false);
  const handleOpenDeleteModal = (vehicule) => {
    setCurrentVehicule(vehicule);
    setOpenDeleteModal(true);
  };

  // ADD MODAL
  const [openAddModal, setOpenAddModal] = useState(false);
  const handleOpenAddModal = () => setOpenAddModal(true);
  const handleCloseAddModal = () => setOpenAddModal(false);

  const [selectedMissionaires, setSelectedMissionaires] = useState([]); 

  // INSERT VEHICULE
  const handleAddVehicule = async (event) => {
    event.preventDefault();
    const form = event.target;
  
    const vehiculeChauffeur = {
      debut: form.debut.value,
      fin: form.fin.value,
      id_chauffeur: form.id_chauffeur.value,
      num_vehicule: form.num_vehicule.value,
      lieu: form.lieu.value,
    };
  
    const missionnaires = selectedMissionaires.map(missionnaire => ({
      id_missionnaire: missionnaire.id,
    }));
  
    const dataToSend = {
      vehicule_chauffeur: vehiculeChauffeur,
      missionnaires: missionnaires,
    };
  
    const result = await ServiceMissionVehicule.add(dataToSend);
    
    if (!result.success) {
      alert(`Erreur lors de l'insertion des données: ${result.error}`);
      return;
    }
    
  
    fetchData();
    handleCloseAddModal();
  };
  
  
  // UPDATE VEHICULE
  const handleUpdateVehicule = async (event) => {
    event.preventDefault();
    const form = event.target;
    const updatedVehicule = {
      debut: form.debut.value,
      fin: form.fin.value,
      id_chauffeur: form.id_chauffeur.value,
      id_chef_mission: form.id_chef_mission.value,
      lieu: form.lieu.value,
      num_vehicule: form.num_vehicule.value
    };
    const result = await ServiceMissionVehicule.update(currentVehicule.id_mission, updatedVehicule);
    if (result.success) {
      fetchData();
      handleCloseEditModal();
    } else {
      alert(result.error);
    }
  };

  // DELETE VEHICULE
  const handleDeleteVehicule = async () => {
    try {
      await ServiceMissionVehicule.delete(currentVehicule.id_mission);
      fetchData();
      handleCloseDeleteModal();
    } catch (error) {
      alert('Erreur lors de la suppression du véhicule.');
    }
  };

  // FONCTION DE RECHERCHE
  const filteredVehicules = vehiculesMission.filter(item => {
    const lowerCaseSearchQuery = searchQuery.toLowerCase().trim();
    return (
      String(item.debut).toLowerCase().includes(lowerCaseSearchQuery) ||
      String(item.fin).toLowerCase().includes(lowerCaseSearchQuery) ||
      String(item.id_chauffeur).toLowerCase().includes(lowerCaseSearchQuery) ||
      String(item.id_chef_mission).toLowerCase().includes(lowerCaseSearchQuery) ||
      String(item.num_vehicule).toLowerCase().includes(lowerCaseSearchQuery) ||
      String(item.lieu).toLowerCase().includes(lowerCaseSearchQuery)
    );
  });

  const formatDateVue2 = (dateString) => {
    const months = ['janv', 'févr', 'mars', 'avr', 'mai', 'juin', 'juil', 'août', 'sept', 'oct', 'nov', 'déc'];
    const [datePart] = dateString.split('T');
    const [year, month, day] = datePart.split('-');
    const formattedMonth = months[parseInt(month) - 1];
    return `${parseInt(day)} ${formattedMonth}`;
  };

  const totalPages = Math.ceil(filteredVehicules.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentVehicules = filteredVehicules.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  return (
    <div className="reunion-container">
      <div>
        <Link style={{color:'black',textDecoration:'none',backgroundColor:'white',borderRadius:'5px',padding:'5px 10px'}} to={"/"}> <ArrowBackIcon fontSize='12px'/> retour</Link>
      </div>
      <div className="titre-page">
        VEHICULE EN MISSION
      </div>
      <hr />
      <div className='ajouter-btn' onClick={handleOpenAddModal}>
        <AddIcon fontSize='small' />
      </div>
      <table className="reunion-table">
        <thead>
          <tr>
            <th>Date Début</th>
            <th>Date Fin</th>
            <th>Chauffeur</th>
            <th>Missionaires</th>
            <th>Véhicule</th>
            <th>Lieu</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {vehiculesMission.map((item, index) => (
            console.log(item),
            <tr key={index}>
              <td>{formatDateVue2(item.date_debut)}</td>
              <td>{formatDateVue2(item.date_fin)}</td>
              <td>{item.code_chauffeur} : {item.prenom_chauffeur}</td>
              <td>{item.missionnaires}</td>
              <td>{item.num_vehicule}</td>
              <td>{item.lieu}</td>
              <td>
                <button className="action-button delete" onClick={() => handleOpenDeleteModal(item)}><ClearIcon fontSize='small' /></button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
 
      <div className="pagination-controls">
        <button
          onClick={() => setCurrentPage(prevPage => Math.max(prevPage - 1, 1))}
          disabled={currentPage === 1}
        >
          Précédent
        </button>
        <span>Page {currentPage} sur {totalPages}</span>
        <button
          onClick={() => setCurrentPage(prevPage => Math.min(prevPage + 1, totalPages))}
          disabled={currentPage === totalPages}
        >
          Suivant
        </button>
      </div>

      <Modal
        open={openEditModal}
        onClose={handleCloseEditModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ maxWidth: 700, margin: 'auto', padding: 2 }}>
          <form id="editForm" onSubmit={handleUpdateVehicule}>
            <div className='titre-form'>
              <span>Modifier Occupation Véhicule</span>
            </div>
            <div className="form-group">
              <label htmlFor="debut">Date Début</label>
              <input type="date" name="debut" id="debut" defaultValue={currentVehicule?.date_debut} required />
            </div>
            <div className="form-group">
              <label htmlFor="fin">Date Fin</label>
              <input type="date" name="fin" id="fin" defaultValue={currentVehicule?.date_fin} required />
            </div>

            <div className="form-group">
              <label htmlFor="id_chauffeur">Chauffeur</label>
              <select name="id_chauffeur" id="id_chauffeur" defaultValue={currentVehicule?.id_chauffeur} required>
                {drivers.map((person, index) =>
                  <option key={index} value={person.id}>{person.code}</option>
                )}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="id_chef_mission">Missionaires</label>
              <select name="id_chef_mission" id="id_chef_mission" defaultValue={currentVehicule?.id_chef_mission} required>
                {personnels.map((person, index) =>
                  <option key={index} value={person.id}>{person.code}</option>
                )}
              </select>
            </div>
            
            <div className="form-group">
              <label htmlFor="num_vehicule">Véhicule</label>
              <select name="num_vehicule" id="num_vehicule" defaultValue={currentVehicule?.num_vehicule} required>
                {vehicules.map((vehicule, index) => (
                  <option key={index} value={vehicule.num_vehicule}>{vehicule.num_vehicule}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="lieu">Lieu</label>
              <input type="text" name="lieu" id="lieu" defaultValue={currentVehicule?.lieu} required />
            </div>

            <div className="btn-container">
            <button type="submit">modifier</button>
          </div>
          </form>
        </Box>
      </Modal>

      <Modal
        open={openAddModal}
        onClose={handleCloseAddModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ maxWidth: 700, margin: 'auto', padding: 2 }}>
          <form id="addForm" onSubmit={handleAddVehicule}>
            <div className='titre-form'>
              <span>Ajouter Occupation Véhicule</span>
            </div>
            <div className="form-group">
              <label htmlFor="debut">Date Début</label>
              <input type="date" name="debut" id="debut" required />
            </div>
            <div className="form-group">
              <label htmlFor="fin">Date Fin</label>
              <input type="date" name="fin" id="fin" required />
            </div>

            <div className="form-group">
              <label htmlFor="id_chauffeur">Chauffeur</label>
              <select name="id_chauffeur" id="id_chauffeur" required>
                {drivers.map((person, index) =>
                  <option key={index} value={person.id}>{person.code} : {person.username}</option>
                )}
              </select>
            </div>

            <Autocomplete
              multiple
              id="id_chef_mission"
              options={personnels}
              getOptionLabel={(option) => option.code}
              renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                  <Chip label={option.code} {...getTagProps({ index })} />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Missionnaires"
                  placeholder="Sélectionner des missionnaires"
                />
              )}
              onChange={(event, newValue) => setSelectedMissionaires(newValue)}
            />

            <div className="form-group">
              <label htmlFor="num_vehicule">Véhicule</label>
              <select name="num_vehicule" id="num_vehicule" required>
                {vehicules.map((vehicule, index) => (
                  <option key={index} value={vehicule.num_vehicule}>{vehicule.num_vehicule}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="lieu">Lieu</label>
              <input type="text" name="lieu" id="lieu" required />
            </div>

            <div className="btn-container">
            <button type="submit">Ajouter</button>
          </div>
          </form>
        </Box>
      </Modal>

      <Modal
        open={openDeleteModal}
        onClose={handleCloseDeleteModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ maxWidth: 300, margin: 'auto', padding: 2 }}>
          <div id="deleteForm" className="deleteForm">
            <center>Confirmer pour supprimer</center>
            <br />
            <center>
            <button onClick={handleDeleteVehicule}>Oui</button>
            <button onClick={handleCloseDeleteModal}>Non</button>
            </center>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default Vehicule;
